export const TOGGLE_SIDEBAR = state => {
  state.sidebarOpen = !state.sidebarOpen;
};
